/**
 * Comprensión con IA opcional (servidor de HabitOS → Ollama u otro proveedor configurado).
 *
 * Híbrida: primero las reglas locales; solo si no están seguras se consulta la IA, y su
 * respuesta pasa por el mismo esquema (`validateUnderstanding`). Si la IA no responde, tarda
 * demasiado, devuelve algo inválido o no mejora a las reglas, se usa lo de las reglas. La IA
 * nunca ve registros: solo el mensaje, la fecha, los nombres y si hay algo pendiente.
 */
import { hybridUnderstander as hybrid } from '@habitos/assistant/assistant/hybrid';
import type { Understander } from '@habitos/assistant/assistant/intents';
import { api } from '../sync/api';

export { cleanAiOutput, dropInvented, RULES_CONFIDENT } from '@habitos/assistant/assistant/hybrid';

export interface AiStatus {
  provider: 'none' | 'ollama' | 'openai';
  model: string | null;
  available: boolean;
  detail: 'ok' | 'disabled' | 'unreachable' | 'model_missing' | 'error';
}

/** Estado real del proveedor. null si no hay servidor (sin conexión o sin backend). */
export async function fetchAiStatus(): Promise<AiStatus | null> {
  try {
    return await api<AiStatus>('/assistant/status');
  } catch {
    return null;
  }
}

/** El intérprete híbrido de la app: la IA se consulta a través del servidor de HabitOS. */
export function hybridUnderstander(opts: { timeoutMs?: number; request?: (body: unknown, signal: AbortSignal) => Promise<unknown> } = {}): Understander {
  return hybrid({
    timeoutMs: opts.timeoutMs,
    request: opts.request ?? ((body, signal) => api<{ understanding: unknown }>('/assistant/understand', { body, signal }).then((r) => r.understanding)),
  });
}
